"use client";

import { c as _c } from "react/compiler-runtime";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useState } from "react";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsBoost from "./WaveDropActionsBoost";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsMore from "./WaveDropActionsMore";
import WaveDropActionsQuickReact from "./WaveDropActionsQuickReact";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean | undefined;
  readonly onReply: () => void;
  readonly onEdit?: (() => void) | undefined;
  readonly suppressed?: boolean | undefined;
}
export default function WaveDropActions(t0) {
  const $ = _c(34);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onEdit,
    suppressed: t2
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const suppressed = t2 === undefined ? false : t2;
  const {
    isMemesWave
  } = useSeizeSettings();
  const compact = useCompactMode();
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  let t3;
  if ($[0] !== drop || $[1] !== isMemesWave || $[2] !== showVoting) {
    t3 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave.id));
    $[0] = drop;
    $[1] = isMemesWave;
    $[2] = showVoting;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const shouldShowVoting = t3;
  let visibilityClasses = "tw-pointer-events-none tw-opacity-0 desktop-hover:group-hover:tw-pointer-events-auto desktop-hover:group-hover:tw-opacity-100 desktop-hover:hover:tw-pointer-events-auto desktop-hover:hover:tw-opacity-100";
  if (isMoreDropdownOpen) {
    visibilityClasses = "tw-pointer-events-auto tw-opacity-100";
  } else {
    if (suppressed) {
      visibilityClasses = "tw-pointer-events-none tw-opacity-0";
    }
  }
  const t4 = `tw-absolute tw-right-2 tw-z-20 ${compact ? "-tw-top-4" : "tw-top-0"} tw-transition-opacity tw-duration-200 tw-ease-in-out ${visibilityClasses}`;
  let t5;
  let t6;
  if ($[4] !== drop) {
    t5 = <WaveDropActionsQuickReact drop={drop} />;
    t6 = <WaveDropActionsAddReaction drop={drop} />;
    $[4] = drop;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== activePartIndex || $[8] !== drop || $[9] !== onReply) {
    t7 = <WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} />;
    $[7] = activePartIndex;
    $[8] = drop;
    $[9] = onReply;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== drop) {
    t8 = <WaveDropActionsBoost drop={drop} />;
    $[11] = drop;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== drop || $[14] !== onEdit) {
    t9 = onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />;
    $[13] = drop;
    $[14] = onEdit;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== drop) {
    t10 = <WaveDropActionsMore drop={drop} onOpenChange={setIsMoreDropdownOpen} />;
    $[16] = drop;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t11 = <div className="tw-flex tw-h-9 tw-items-center tw-gap-x-0.5 tw-rounded-xl tw-bg-iron-950 tw-px-1 tw-shadow-md tw-shadow-black/20 tw-ring-1 tw-ring-inset tw-ring-iron-700/40">{t5}{t6}{t7}{t8}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== drop || $[26] !== shouldShowVoting) {
    t12 = shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[25] = drop;
    $[26] = shouldShowVoting;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-2">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t4) {
    t14 = <div className={t4}>{t13}</div>;
    $[31] = t13;
    $[32] = t4;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}